import { Box, Menu, MenuItem, useTheme } from '@mui/material';
import { PatientRouteMap } from '_constants';
import { TextButton } from 'components/atoms';
import { PatientCardText } from 'components/atoms/typographyStyles';
import React, { useMemo, useState } from 'react';
import { MdOutlineOpenInNew } from 'react-icons/md';
import { useNavigateTo } from 'utils';

import { ViewProfileMenuProps } from './types';

export const ViewProfileMenu = ({ patients }: ViewProfileMenuProps) => {
  const theme = useTheme();
  const navigate = useNavigateTo();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = useMemo(() => Boolean(anchorEl), [anchorEl]);

  const viewProfile = (id: number | string) => {
    navigate(PatientRouteMap.DETAIL, id.toString(), true);
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (patients.length == 1) {
      viewProfile(patients[0].id);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const onPatientSelect = (id: string | number) => {
    viewProfile(id);
    setAnchorEl(null);
  };

  return (
    <div>
      <TextButton
        onClick={handleClick}
        sx={{ color: theme.palette.primary.main, float: 'right' }}
      >
        VIEW PROFILE <MdOutlineOpenInNew />
      </TextButton>
      <Menu anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}>
        {patients.map((patient) => (
          <MenuItem
            key={`patient-${patient.id}-menu-item`}
            onClick={() => onPatientSelect(patient.id)}
          >
            <Box>
              <PatientCardText>
                {patient.firstName} {patient.lastName}
              </PatientCardText>
            </Box>
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};
